export default "__VITE_ASSET__rnJw2mUZ__"